import _ from 'lodash';
import {RouteService} from '../../../../services/routeService';
import {NotificationService} from '../../../../services/notificationService';
import {GeneralService} from "../../../../services/generalService";
import {DICTIONARY} from "../../../../dictionary";
import {Component, OnInit} from "@angular/core";

@Component({
	selector: 'admin-audit-log-component',
	templateUrl: './admin-audit-log.component.html',
})
export class AdminAuditLogComponent implements OnInit {
	constructor(public gs:GeneralService,
				private rs:RouteService,
				private ns:NotificationService) {

	}

	dic = DICTIONARY;
	_ = _;
	loadingLogsInProcess = true;
	filterData;
	logs;

	showAbortLoadingLabel: boolean;
	abortLoadingFlag: any;
	scheduleReportShow = false;

	auditLogsPeriod = [
		this.dic.CONSTANTS.trendsPeriod.lastDay,
		this.dic.CONSTANTS.trendsPeriod.last3Days,
		this.dic.CONSTANTS.trendsPeriod.lastWeek,
		this.dic.CONSTANTS.trendsPeriod.lastMonth,
		this.dic.CONSTANTS.trendsPeriod.all
	];
	period = this.dic.CONSTANTS.trendsPeriod.last3Days;
	range = {start: new Date(Date.now() - (1000 * 60 * 60 * 24 * 7)), end: new Date()};
	showCustomPeriodDropdown = false;

	ngOnInit() {
		this.initFilters();
		this.getAdminAuditLogs();
	};

	ngOnDestroy(): void {
		this.abortLoadingFlag = true;
	}

	changePeriod = (inputPeriod) => {
		this.period = inputPeriod;
		if (this.period.value === this.dic.CONSTANTS.trendsPeriod.range.value) {
			return;
		}
		this.getAdminAuditLogs();
	};

	// CC: taken from inbound-trends.component.ts -> getTrendsByRangeDates
	getLogsByRangeDates = () => {
		if (this.period.value !== this.dic.CONSTANTS.trendsPeriod.range.value) {
			return;
		}
		let range: any = {
			start: this.range.start,
			end: this.range.end
		};
		if (range.start > Date.now() || range.start > range.end) {
			this.ns.showWarnMessage(this.dic.ERRORS.adminTrendsDate);
			return;
		}
		this.getAdminAuditLogs();
	};

	getAdminAuditLogs = () => {
		this.loadingLogsInProcess = true;
		this.abortLoadingFlag = false;
		this.showAbortLoadingLabel = true;

		const params: any = {period: this.period.value};
		if (this.period.value === this.dic.CONSTANTS.trendsPeriod.range.value) {
			params.range = this.range;
		}

		this.rs.getAdminAuditLogs(params).then((response) => {
			this.logs = response;
			this.logs.forEach((logObj) => {
				logObj.module = returnLogModule(logObj);
			});

			this.getNextLogsBatch(() => {});

			this.loadingLogsInProcess = false;
		}, (err) => {
			this.loadingLogsInProcess = false;
		});
	};

	getNextLogsBatch = (cb) => {
		if (!this.logs?.length) {
			this.showAbortLoadingLabel = false;
			return cb();
		}

		if (this.abortLoadingFlag) {
			this.abortLoadingFlag = false;
			return;
		}

		const params: any = {period: this.period.value, lastCreated: this.logs[this.logs.length - 1].created};
		if (this.period.value === this.dic.CONSTANTS.trendsPeriod.range.value) {
			params.range = this.range;
		}
		this.rs.getAdminAuditLogs(params).then((response) => {
			if (response?.length) {
				this.logs = this.logs.concat(response);
				this.logs.forEach((logObj) => {
					logObj.module = returnLogModule(logObj);
				});

				this.getNextLogsBatch(cb);
			}
			else {
				this.showAbortLoadingLabel = false;
			}
		});
	}

	abortLoadingLogs = () => {
		this.abortLoadingFlag = true;
		this.loadingLogsInProcess = false;
		this.showAbortLoadingLabel = false;
	}

	showScheduleReport = () => {
		this.scheduleReportShow = true;
	}

	searchLogs = (event) => {
		this.logs.forEach(record => {
			// search
			if (event.searchTerm) {
				const isFound = searchTextExecute(record, event.searchTerm);
				if (!isFound) {
					record.hide = true;
					return;
				}
			}

			// filter
			if (event.activeFilters) {
				// need to match all filter types
				let numFilterToMatch = Object.keys(event.activeFilters).length;

				if (event.activeFilters.module?.length) {
					if (event.activeFilters.module.includes(record.module)) {
						numFilterToMatch--;
					}
				}

				if (numFilterToMatch) {
					record.hide = true;
					return;
				}
			}

			record.hide = false;
		});
	};

	exportToCsv = (sortBy) => {
		if (!this.logs || !this.logs.length) {
			this.ns.showWarnMessage(this.dic.ERRORS.noDataToExportCsv);
			return;
		}

		let csvString = "Date,Module,Category,Admin,Action\n";

		let sortedTable = _.filter(this.logs,incident => {return !incident.hide});
		if (sortBy) {
			sortedTable = this.gs.sortTable(sortedTable, sortBy);
		}

		sortedTable.forEach((log) => {
			csvString += `${log.created},"${log.module}","${log.category}",${log.admin},"${log.action}"\n`;
		});

		this.gs.exportCsv(csvString, `audit_logs.csv`);
	};

	initFilters = () => {
		this.filterData = {
			filterType : this.dic.CONSTANTS.tableFilters.auditLogDomain,
			filters: {
				module: ['Outbound Shield', 'Inbound Shield', 'Simulation and Training', 'Domain Protection', '' +
				'Account Takeover', 'Collaboration Protection', 'Archive']
			},
			initFiltersFunction: this.initFilters
		};
	};
}

function returnLogModule(logObj) {
	switch (logObj.audit_log_type) {
		case 'Inbound':
			return 'Inbound Shield';

		case 'Outbound':
			return 'Outbound Shield';

		case 'Threat Simulation':
			return 'Simulation and Training';

		case 'Archive':
			return 'Archive';

		case 'Account Compromised':
			return 'Account Takeover';

		case 'Domain':
			return 'Domain Protection';

		case 'Collaboration Protection':
			return 'Collaboration Protection';
	}
}

function searchTextExecute(log, searchTerm) {
	return ((log.action?.toLowerCase().indexOf(searchTerm) > -1) ||
		(log.admin?.toLowerCase().indexOf(searchTerm) > -1) ||
		(log.audit_log_type?.toLowerCase().indexOf(searchTerm) > -1) ||
		(log.category?.toLowerCase().indexOf(searchTerm) > -1));
}
